import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setCostCenterHistoryLogsLoading
    , getCostCenterHistoryLogs
    , setCostCenterHistoryPageSize
    , resetCostCenterHistory
    , setCostCenterHistoryColSearchStr,
} from '../../../../constants/model-reducers/external/finance/history/cost-center-history.settings';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});
 
const initialState = defaultState();

export const costCenterHistoryActions = {
    getCostCenterHistoryLogs: (costCodeId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().costCenterHistory.HistoryTable;
        var formData = {
            CostcodeID: costCodeId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setCostCenterHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/finance/getCostCenterHistoryLogs', formData);

        dispatch({
            type: getCostCenterHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeCostCenterHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setCostCenterHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extracCostCodeHistoryLogs: (costCodeId) => async (dispatch, state) => {
        const { Headers } = state().costCenterHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Cost Center History – ${formattedTimeZoneDate}`;
        
        var formData = {
            CostcodeID: costCodeId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/finance/getExtractCostcode', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setCostCenterHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().costCenterHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setCostCenterHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetCostCenterHistory: () => (dispatch, state) => {
        dispatch({
            type: resetCostCenterHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCostCenterHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getCostCenterHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setCostCenterHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setCostCenterHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetCostCenterHistory:
            return initialState;
        default:
            return state;
    }
}